import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "#app/components/auth/auth-layout";
import { RegisterForm } from "#app/components/auth/register-form";

function RegisterScreen() {
  return (
    <AuthLayout
      heading="Create Account"
      subheading="Fill in your details to get started"
      footerText="Already have an account?"
      footerLinkText="Sign in"
      footerLinkHref="/login"
    >
      <RegisterForm />
    </AuthLayout>
  );
}

export const Route = createFileRoute("/(auth)/register")({
  component: RegisterScreen,
});
